import styled from 'styled-components'

export const Card = ({ children,className,...props }) => {
  return (
    <CardContainer className={className} {...props}>
      {children}
    </CardContainer>
  )
}

export const CardContainer = styled.div`
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  width: 100%;
  min-width: 20em;
  background-color: var(--cardColor);
  color: var(--text);
 
  ${props => props.css}
`
